import React from 'react';
import { useSelector } from 'react-redux';
import {
  isIntervalGreaterThanADaySelector,
  isIntervalOlderThanThirtyDaysSelector,
} from '@store/overviewDashboard/base/selectors';
import { ViewerWidgetWrapper } from './styled';
import Table from './Table';
import Title from './Title';

function ViewerSession() {
  // do not show viewers table for more than 24h within 30d
  const isIntervalGreaterThanADay = useSelector(isIntervalGreaterThanADaySelector);
  const isIntervalOlderThanThirtyDays = useSelector(isIntervalOlderThanThirtyDaysSelector);

  if (isIntervalGreaterThanADay || isIntervalOlderThanThirtyDays) {
    return <div style={{ height: 200, margin: '20px 10px' }}>Please select a valid time range.</div>;
  }

  return (
    <ViewerWidgetWrapper>
      <Title />
      <Table />
    </ViewerWidgetWrapper>
  );
}

export default ViewerSession;
